import {sum} from './core.js'

const headerSumLines = (data, operation) => {
    const { fieldsToOperate, targetField, subEntity } = operation
    let result = 0

    if (!data[subEntity] || !Array.isArray(data[subEntity])) {
        return data
    }

    for (const elem of data[subEntity]) {
        result += sum(elem, fieldsToOperate)
    }

    const value = parseFloat(result.toFixed(2))

    if (typeof targetField === 'string' && targetField.includes('.')) {
        const dot = targetField.indexOf('.')
        const parent = targetField.substring(0, dot)
        const child = targetField.substring(dot + 1)
        return { ...data, [parent]: { ...(data[parent] || {}), [child]: value } }
    }

    return { ...data, [targetField]: value }
}

export default headerSumLines
